import React from "react";
import { useFormEditorContext } from "../../Contexts/FormEditorContext";
import { QUESTION_OBJECTS } from "../../Constants/questionTypes";
import { ActionType } from "../../features/logic/types/zustand.ts";
// import { useLogicStore } from "../../features/logic/store/use-logic-store.ts";
import { useLogicV2 } from "../../features/logic/hooks/use-logic-v2.ts";

import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogFooter,
    DialogHeader,
    DialogTrigger,
    DialogClose,
} from "../ui/dialog.tsx";
import { Separator } from "../ui/separator.tsx";
import { Button } from "../ui/button.tsx";
import { TriangleAlert } from "lucide-react";
export const SiderFieldCard = ({ field, index, label = null }) => {
    const {
        selectedField,
        setSelectedField,
        fields,
        setFields,
        setWelcomeScreen,
        setIsWelcomeIsEnabled,
        setEndScreen,
        setIsEndIsEnabled,
        isWelcomeIsEnabled,
        isEndIsEnabled,
        endScreen,
        logics,
        removeField: removeFieldFromContext,
    } = useFormEditorContext();

    // const logicDispatch = useLogicStore((state) => state.dispatch);

    const { dispatch: logicV2Dispatch } = useLogicV2();

    const isSelected =
        (selectedField?.id && selectedField?.id === field?.id) ||
        (selectedField === "welcome-screen" && field === "welcome-screen") ||
        (selectedField === "end-screen" && field === "end-screen");

    const removeField = (fieldId) => {
        const _index = fields.findIndex((f) => f?.id === fieldId);
        const updatedFields = fields.filter((f) => f?.id !== fieldId);

        const fieldToBeRemovedLogic = logics.find(
            (logic) => logic.fieldId === fieldId,
        );
        const defaultFieldIdNextToFieldToBeRemoved = logics?.find(
            (logic) =>
                logic?.defaultTargetId ===
                fieldToBeRemovedLogic?.defaultTargetId,
        );

        setFields(updatedFields);
        const index =
            _index === 0
                ? isWelcomeIsEnabled
                    ? "welcome-screen"
                    : null
                : fields[_index - 1];
        setSelectedField(index);
        // removeFieldFromContext(fieldId);

        // const fieldToBeRemoved = fields.find((f) => f?.id === fieldId);
        logicV2Dispatch({
            type: ActionType.REMOVE_LOGIC,
            payload: {
                fieldId,
            },
        });
    };

    const removeWelcomeScreen = () => {
        setWelcomeScreen({});
        setIsWelcomeIsEnabled(false);
        const index =
            fields.length > 0
                ? fields[0]
                : isEndIsEnabled
                ? "end-screen"
                : null;

        console.log("index", index);
        setSelectedField(index);
    };

    const removeEndScreen = () => {
        setIsEndIsEnabled(false);
        const index =
            fields?.length > 0
                ? fields[fields.length - 1]
                : isWelcomeIsEnabled
                ? "welcome-screen"
                : null;
        setSelectedField(index);
        // logicDispatch({
        //     type: ActionType.REMOVE_FIELD,
        //     payload: {
        //         fieldId: endScreen.id,
        //     },
        // });
        setEndScreen({});

        logicV2Dispatch({
            type: ActionType.REMOVE_LOGIC,
            payload: {
                fieldId: endScreen.id,
            },
        });
    };

    function getFieldName(field) {
        if (field?.type === "ai_statement") {
            return "AI Statement";
        } else if (field?.type === "section") {
            return "Statement";
        } else if (field === "welcome-screen") {
            return "Welcome Screen";
        } else if (field === "end-screen") {
            return "End Screen";
        } else if (field?.title) {
            return field?.title;
        } else if (field?.type) {
            return field?.type.replace(/_/g, " ");
        } else {
            return "Untitled Field";
        }
    }

    return (
        <div className="relative w-full max-w-[290px] hover:cursor-pointer group">
            <button
                className={`relative flex items-center hover:cursor-pointer w-full pl-0.5  transition duration-150 pr-6 rounded-lg  hover:bg-[#F7F8F9] ${
                    isSelected
                        ? "bg-[#F1F2F4]"
                        : " border rounded-[8px] border-gray-100"
                }`}
                key={index}
            >
                <button className="pl-2 pr-1.5 h-8 ">
                    {field === "welcome-screen" || field === "end-screen" ? (
                        <div
                            className="flex  items-center   justify-center rounded-sm w-[42px] h-[20px] "
                            style={{
                                backgroundColor: isSelected
                                    ? "white"
                                    : "#F1F2F4",
                            }}
                        >
                            {field === "welcome-screen" ? (
                                <p className=" font-semibold capitalize text-[#091E42] text-[10px]">
                                    START
                                </p>
                            ) : (
                                <p className=" font-semibold capitalize text-[#091E42] text-[10px]">
                                    END
                                </p>
                            )}
                        </div>
                    ) : (
                        <FieldTypeIndicator
                            field={field}
                            index={index}
                            isSelected={isSelected}
                        />
                    )}
                </button>

                <button
                    className="text-xs text-start px-1.5 capitalize font-normal w-full text-[#191B33]  focus:outline-none py-3 truncate"
                    onClick={() => {
                        setSelectedField(field);
                    }}
                >
                    {getFieldName(field)}
                </button>

                {/* For regular fields */}
                {field !== "end-screen" && field !== "welcome-screen" && (
                    <DeleteButton
                        onDelete={() => removeField(field?.id)}
                        type={"field"}
                    />
                )}

                {field === "welcome-screen" && (
                    <DeleteButton
                        className={""}
                        onDelete={() => removeWelcomeScreen()}
                        type={"welcome-screen"}
                    />
                )}
                {field === "end-screen" && (
                    <DeleteButton
                        className={""}
                        onDelete={() => removeEndScreen()}
                        type={"end-screen"}
                    />
                )}
            </button>
        </div>
    );
};

const FieldTypeIndicator = ({ field, index, isSelected }) => {
    const fieldObject = QUESTION_OBJECTS[field?.type];
    const fieldIcon = fieldObject?.icon;
    const fieldColor = fieldObject?.color;
    const textColor = fieldObject?.textColor;

    return (
        <div
            className="flex items-center justify-center gap-1.5 hover:cu rounded-sm w-[42px] h-[22px]  "
            style={{ backgroundColor: isSelected ? "white" : "#F1F2F4" }}
        >
            <span
                className="leading-4 text-[10px] font-semibold"
                style={{ textColor: "#091E42" }}
            >
                {index > 9 ? "" : "0"}
                {index}
            </span>

            <span className="flex items-center w-3 h-3 font-bold ">
                {fieldIcon}
            </span>
        </div>
    );
};

const DeleteButton = ({ onDelete, className, type }) => {
    function getTitle() {
        switch (type) {
            case "field":
                return "Delete this Question?";
            case "welcome-screen":
                return "Delete Welcome Screen?";
            case "end-screen":
                return "Delete End Screen?";
            default:
                return "Delete?";
        }
    }

    function getDescription() {
        switch (type) {
            case "field":
                return (
                    <p className="text-[#191B33] w-full text-sm px-3">
                        You set up logic rules for this question. <br /> If you
                        delete it, you’ll break the logic.
                    </p>
                );
            case "welcome-screen":
                return (
                    <p className="text-[#191B33] w-full text-sm px-3">
                        You set up logic rules for this welcome screen. <br />{" "}
                        If you delete it, you’ll break the logic.
                    </p>
                );
            case "end-screen":
                return (
                    <p className="text-[#191B33] w-full text-sm px-3">
                        You set up logic rules for this end screen.
                        <br /> If you delete it, you’ll break the logic.
                    </p>
                );

            default:
                return "You set up logic rules for this item. If you delete it, you’ll break the logic.";
        }
    }

    return (
        <Dialog>
            <DialogTrigger asChild>
                <button
                    className={`
        absolute z-50 flex items-center justify-center 
        w-5 h-5 p-1 transition-opacity duration-200 
        transform -translate-y-1/2 rounded-full 
        opacity-0 right-[12px] text-zinc-800 top-1/2 
        group-hover:opacity-100 hover:cursor-default hover:opacity-100 
        ${className}
      `}
                    //  onClick={onDelete}
                >
                    <svg
                        width="12"
                        height="12"
                        viewBox="0 0 7 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M6.5 1.34961L0.5 7.34961M0.5 1.34961L6.5 7.34961"
                            stroke="#44546F"
                            strokeWidth="0.75"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
            </DialogTrigger>
            <DialogContent className="top-[50%] w-auto lg:max-w-full p-0">
                <DialogHeader className="px-3 pt-3 space-y-0">
                    <DialogTitle className="flex flex-row items-center gap-2 text-sm">
                        <TriangleAlert className="w-3 h-3" />
                        {getTitle()}
                    </DialogTitle>
                </DialogHeader>
                <Separator className="" />
                <div className="w-full min-w-[380px] ">{getDescription()}</div>
                <Separator className="" />
                <DialogFooter className="px-3 gap-1.5 lg:gap-0 pb-3">
                    <DialogClose className="h-[36px] flex items-center justify-center py-3 px-4 font-medium border border-[#D1D5DB] rounded-[8px] text-sm">
                        Cancel
                    </DialogClose>
                    <Button
                        variant="destructive"
                        className="bg-[#F44336] h-[36px] text-sm"
                        onClick={onDelete}
                    >
                        Yes, delete it
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
